module.exports = __webpack_public_path__ + "static/media/logo.288810a4.png";